/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Kind_SaleInputs */

const vi_cdo_kind_sale = /** @type {(inputs: Cdo_Kind_SaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn hàng`)
};

/**

* @param {Cdo_Kind_SaleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_kind_sale = /** @type {((inputs?: Cdo_Kind_SaleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Kind_SaleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_kind_sale(inputs)
});